/**
 * useUserRole (SPEC §5) — reads the shared user state (loaded once by UserProvider
 * from GET /users/me). Exposes the identity, role, stores, and role flags.
 */
import { useUserState, type UserState } from '@/hooks/UserProvider';

export function useUserRole(): UserState {
  return useUserState();
}
